module.exports = __webpack_public_path__ + "media/wav1.49cf639f.mp4";